/*{ ------------------- Icons & Buttons ------------------------} */
import AddIcon from '@mui/icons-material/Add';
import deleteIcon from "../../assets/images/delete.svg"
import { AiOutlineCloudUpload } from "react-icons/ai";
import { Avatar, Badge,AvatarGroup, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import EditIcon from "../../assets/images/editIcon.png"
import rejectIcon from '../../assets/icons/dashicons_no.png'

/*{ ------------------- import components ------------------------} */
import FormField from '../../components/Common-components/form-input';
import TableHeadings from '../../components/Common-components/table-headings';
import { Pagination } from '../../components/Pagination';
import Modal from '../../components/PopUpModal'
import DeleteModal from '../../components/Modal/delete-modal';
import useDragDrop from '../../hooks/useDrag&Drop';
import useMuiCustom from '../../hooks/useMuiCustom';
import { Spinner } from '../../components/Common-components/spinner';
// import { imageUrl, Validation } from '../../components/Constant';
// import useBanner from '../vendor_management/hook/useBanner';
import DateInput from '../../components/DateInput'
import moment from 'moment-timezone';
import useLanguage from '../../hooks/useLanguage';
import { IoClose } from "react-icons/io5";
// import { useCheckPermission } from '../../hooks/useCheckPermission';
// import NoPermissionMessage from '../../components/Common-components/noPermissionMessage';
import { FaRegCheckCircle, FaVideo } from "react-icons/fa";
import SearchFilter from '../../components/Common-components/serchFillter';
import { Validation, imageBaseUrl } from '../../components/Constant';
import useBanner from './hook/useBanner';

const Banner = () => {
    const { t, isEngLang } = useLanguage();
    const { methods, data } = useBanner();
    const { SmallAvatar, CustomWidthTooltip } = useMuiCustom();
    const { handlePagination, handleClosedModal, handleOpenModal, getDetails,
        handleInputChange,
        handleBlur,
        handleAddSubmit,
        handleEditSubmit,
        handleDelete,
        uploadBanner,
        setBannerInput,
        clear,
        handleReject,
        setRejectRemark,
        handleApprove,
        HandleSearch,handleChangeFilter,reset
    } = methods
    const { controller, TableHeadData, totalCount, openModal, uploadImgRef,
        BannerInput,
        error,
        spinner,
        filter,
        listData,
        rejectRemark
    } = data
    const { handleDragEnter, handleDragLeave, handleDragOver, handleDrop } = useDragDrop()

    // const checkPermission = useCheckPermission();
    // const editSetup = checkPermission("setup", "edit")
    // const viewSetup = checkPermission("setup", "view")
    // const addSetup = checkPermission("setup", "add")

    // if (!editSetup) TableHeadData?.pop()

    return (
        <>
            {spinner && <Spinner />}
            <div className='container-fluid d-flex flex-column justify-content-between flex-fill h-100'>
                 <h1 className="font-18 black-color pb-2 px-2">{`${t('sideBar.banner')}`}</h1>
                <div className='px-2'>
                    <div className=" d-flex justify-content-start">
                         <SearchFilter
                            handleSearch={HandleSearch}
                            handleFilterInput={handleChangeFilter}
                            value={filter?.search}
                            reset={reset}
                            otherAction={
                                <>
                            <button
                                className="custom_button ms-3  bg-green-color white-color align-items-center"
                                onClick={() => { handleOpenModal("addBanner"); clear() }}>
                                <AddIcon size={20} className="me-1" />
                                <span className="me-1"> {`${t("buttonTitle.add")} ${t("sideBar.banner")}`} </span>
                            </button>
                                </>
                            }
                        />
                    </div>
                </div>

                {/* {
                    viewSetup ? <> */}

                        <div className="table-responsive custom_table px-2 flex-fill mt-3 custom_scroll">
                            <table className="table cus-table">
                                <TableHeadings TableHeadData={TableHeadData} controller={controller} setController={handlePagination} />
                                <tbody>
                                    {listData?.map((cur, index) => (
                                        <>
                                            <tr >
                                                <td>{controller?.rowsPerPage * (controller?.page - 1) + index + 1}</td>
                                                <td className=" d-flex justify-content-center">
                                                    <Avatar alt={cur?.image} src={`${imageBaseUrl}banner/${cur?.image}`} />
                                                </td>
                                                <td>{cur?.name}</td>
                                                <td>{moment(cur?.startDate).format('DD/MM/YYYY')}</td>
                                                <td>{moment(cur?.endDate).format('DD/MM/YYYY')}</td>
                                                <td>{cur?.status}</td>
                                                {
                                                  <td>
                                                   {/* {
                                                            cur?.status !== "Accepted" ? <CustomWidthTooltip title={<span className="fw-4 font-12 black-color">{`${t("buttonTitle.approve")}`}</span>} placement="left-start" >
                                                                <IconButton onClick={() => handleApprove(cur?._id)}>
                                                                    <FaRegCheckCircle size={20} style={{ color: "#44D36C" }} />
                                                                </IconButton>
                                                            </CustomWidthTooltip> : <CustomWidthTooltip title={<span className="fw-4 font-12 black-color">{`${t("formTitle.reject")}`}</span>} placement="left-start" >
                                                                <IconButton onClick={() => handleOpenModal("reject", cur)}>
                                                                    <img src={rejectIcon} alt="" height={25} width={25} />
                                                                </IconButton>

                                                            </CustomWidthTooltip>

                                                   } */}
                                                        <CustomWidthTooltip title={<span className="fw-4 font-12 black-color">{`${t("buttonTitle.delete")}`}</span>} placement="left-start" >
                                                            <img src={deleteIcon} alt="" className='me-2 cursor' onClick={() => handleOpenModal("deleteBanner", cur)} />
                                                        </CustomWidthTooltip>
                                                        <CustomWidthTooltip title={<span className="fw-4 font-12 black-color">{`${t("buttonTitle.edit")}`}</span>} placement="left-start" >
                                                            <img src={EditIcon} alt="" className='me-2 cursor' onClick={() => handleOpenModal("addBanner", cur)} />
                                                        </CustomWidthTooltip>
                                                    </td>
                                                }

                                            </tr>
                                            <tr className='default_tr_gap'></tr>
                                        </>
                                    ))}
                                </tbody>
                            </table>
                            {!listData?.length && <div className="text-center my-2">{`${t("tableTitle.noRecordFound")}`}</div>}
                        </div >
                        {
                            totalCount > 10 && <div >
                                <Pagination count={totalCount} controller={controller} setController={handlePagination} />
                            </div>
                        }
{/* 
                    </> : <NoPermissionMessage className='px-2 flex-fill mt-3 d-flex justify-content-center align-items-center h-100' />
                } */}
                {/* Add Banner Image */}
                <Modal className="p-0"
                    size="md"
                    onHide={() => handleClosedModal('addBanner')}
                    show={openModal?.addBanner}
                    headerBorderBottom={false}
                    headerContent={<h5 className="m-0 black-color fw-6 font-15 text-center w-100 required={true}">
                        {`${openModal?.data ? t("buttonTitle.edit") : t("buttonTitle.add")}  ${t("formTitle.bannerImage")} `}</h5>}
                    bodyContent={
                        <div className="container-fluid">
                            <div className="col-12">
                                <div className="col-12 mt-2 ">
                                    <FormField required={true}
                                        name={'name'}
                                        value={BannerInput?.name}
                                        onBlur={(e) => handleBlur(e)}
                                        onChange={(e) => handleInputChange(e)}
                                        data={{ label: `${t("formTitle.bannerName")}`, type: 'text' }}
                                        error={error?.name}
                                    />
                                </div>
                                <div className="row">
                                    <div className="col-12 d-flex justify-content-between">
                                        <div className={`col-6 mt-2 pe-2 ${!isEngLang && 'ps-2'}`}>
                                            <DateInput
                                                minDate={new Date()}
                                                isRequired={true}
                                                size="small"
                                                variant="outlined"
                                                className=" form-field-design w-100 fullWidth black-color"
                                                Label={`${t("formTitle.startDate")}`}
                                                SelectedDate={BannerInput?.startDate || null}
                                                // SelectedDate={inputValues?.startDate ? new Date(inputValues.startDate) : new Date()}
                                                error={error?.startDate}
                                                handleDateChange={(date) => handleInputChange({ target: { name: "startDate", value: date } })}
                                            />
                                        </div>
                                        <div className={`col-6 mt-2 ps-2 ${!isEngLang && 'pe-2'}`}>
                                            <DateInput
                                                minDate={new Date()}
                                                isRequired={true}
                                                size="small"
                                                variant="outlined"
                                                className=" form-field-design w-100 fullWidth black-color"
                                                Label={`${t("formTitle.endDate")}`}
                                                SelectedDate={BannerInput?.endDate || null}
                                                // SelectedDate={inputValues?.endDate ? new Date(inputValues.endDate) : new Date()}
                                                error={error?.endDate}
                                                handleDateChange={(date) => handleInputChange({ target: { name: "endDate", value: date } })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 mt-3">
                                        <div className="d-flex flex-wrap">
                                            {BannerInput.image && (
                                                <div
                                                    className='rounded me-2 mb-2 position-relative bg-blur'
                                                    style={{ width: "180px", height: "150px" }}
                                                >
                                                    {Validation?.pattern?.isValidVideo.test(BannerInput.image) ? (
                                                        <video
                                                            playsInline
                                                            autoPlay
                                                            muted
                                                            loop
                                                            className='w-100 h-100 rounded-4'
                                                            style={{ objectFit: 'cover', borderRadius: '12px' }}
                                                        >
                                                            <source src={`${imageBaseUrl}banner/${BannerInput.image}`} />
                                                        </video>
                                                    ) : (
                                                        <img
                                                            className='rounded'
                                                            src={`${imageBaseUrl}banner/${BannerInput.image}`}
                                                            alt=""
                                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                        />
                                                
                                                    )}
                                                    <span
                                                        className='position-absolute cursor'
                                                        style={{ top: "0px", right: "10px", color: "black" }}
                                                        onClick={() => setBannerInput((prev) => ({ ...prev, image: null }))}
                                                    >
                                                        <IoClose />
                                                    </span>
                                                </div>
                                            )}

                                            {
                                                !BannerInput.image && <div
                                                    className="drag-drop w-100"
                                                    style={{ border: `2px dashed #2F90EA` }}
                                                    onDragEnter={handleDragEnter}
                                                    multiple
                                                    onDragLeave={handleDragLeave}
                                                    onDragOver={handleDragOver}
                                                    onDrop={(e) => handleDrop(e, uploadBanner)}
                                                >
                                                    <label htmlFor="inputTag" className='w-100'>
                                                        <AiOutlineCloudUpload className="fs-4 blue-color" />
                                                        <input
                                                            accept="image/*,video/*"
                                                            id="inputTag"
                                                            type="file"
                                                            name="file"
                                                            ref={uploadImgRef}
                                                            onChange={(event) => uploadBanner(event.target.files[0])}
                                                            multiple
                                                        />
                                                        <br />
                                                        <p className="mb-0 blue-color font-12 mt-2">
                                                            {`${t("formTitle.drag&Drop")}`}
                                                        </p>
                                                        <div className='horizontal_line my-3'>
                                                            <span>{`${t("formTitle.or")}`}</span>
                                                        </div>
                                                        <p className="custom_button bg-blue-color white-color font-12 px-2 py-2 mt-0 cursor d-inline-block">
                                                            {`${t("buttonTitle.selectFileUpload")}`}
                                                        </p>
                                                    </label>
                                                </div>
                                            }


                                        </div>
                                        {
                                            error?.image && <div className='font-11 mt-1 red-color w-50'>{error?.image}</div>
                                        }
                                    </div>

                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-center py-4">
                                <button className="custom_button bg-blue-color2 white-color font-14 px-4 py-2" onClick={handleAddSubmit}> {openModal?.data?._id ? `${t("buttonTitle.update")}` : `${t("buttonTitle.submit")}`}</button>
                            </div>
                        </div>
                    }
                />

                  <Modal
                headerBorderBottom={true}
                className="p-0"
                size="md"
                onHide={() => handleClosedModal('reject')}
                show={openModal?.reject}
                bodyContent={
                    <div className='py-4' >
                        <div className="text-center">
                            <img src={rejectIcon} alt="" height={44} width={44} />
                            <div className="fw-6 font-18 my-3">{`${t("formTitle.reject")} `}</div >
                            <div className="grey-color1 font-15 my-2 " >
                                {`${t("messageText.youAreAboutTo")} ${t("formTitle.reject")}`} <span className='blue-color5'>{openModal?.data?.name}</span><br />{t("messageText.sure")}
                            </div>
                        </div>
                        <div className="row px-3 my-4">
                            <div className="col-12">
                                <label className={'fw-5 font-12 grey-color1   p-0 text-nowrap'}>{t("filterTitle.reason")}<span className="text-danger">*</span></label>
                                <textarea value={rejectRemark?.value} onChange={(e) => setRejectRemark((pre) => ({ ...pre, value: e.target.value, error: "" }))} className="form-control textarea" id="exampleFormControlTextarea1" rows="5"></textarea>
                                {rejectRemark?.error && <div className='font-11 mt-1 red-color'>{rejectRemark?.error}</div>}
                            </div>
                        </div>
                        <div className="d-flex justify-content-center ">
                            <button className="custom_button bg-light-orange-color1 white-color font-14 px-5 py-2" onClick={handleReject} >{`${t("formTitle.reject")}`}</button>
                        </div>
                    </div>
                }
            />
            </div >
            <DeleteModal show={openModal?.deleteBanner} closeModal={() => handleClosedModal('deleteBanner')} handleDelete={handleDelete} deleteName={openModal?.data?.bannerImageName} deleteTtpe={`${t("buttonTitle.delete")}`} />
        </>
    )
}
export default Banner
